<template>
  <div>
    <div class="shcedule-con">
      <div class="table">
        <div class="table-header" :class="{ special: special }">
          <div class="td td1">
            <p>{{ header[0] }}</p>
          </div>
          <div class="td td2">
            <p>{{ header[1] }}</p>
            <!-- <p class="utc-p">(UTC-5)</p> -->
          </div>
          <div class="td td3">
            <p>{{ header[2] }}</p>
          </div>
          <div class="td td4">
            <p>{{ header[3] }}</p>
          </div>
          <div class="td td5">
            <p>{{ header[4][0] }}</p>
            <p>{{ header[4][1] }}</p>
            <p>{{ header[4][2] }}</p>
            <!-- <p>REBUY/</p>
            <p>ADD-ON</p> -->
          </div>
          <div class="td td6">
            <p>{{ header[5][0] }}</p>
            <p>{{ header[5][1] }}</p>
            <!-- <p>CHIPS</p> -->
          </div>
          <div class="td td7">
            <p>{{ header[6] }}</p>
          </div>
          <div class="td td8">
            <p>{{ header[7] }}</p>
          </div>
        </div>

        <div class="over_body" v-bar>
          <div>
            <div v-for="(scheduleItem, ind) in scheduleFormat" :key="ind" class="table_big_item">
              <div class="schedule_date">
                <p>{{ scheduleItem.date | format }}</p>
              </div>

              <div class="table_item" v-for="(item, index) in scheduleItem.list" :key="index" :class="{ hl: item.is_hg === 1 }">
                <div class="td td1">
                </div>
                <div class="td td2">
                  <p>{{ item.time }}</p>
                </div>
                <div class="td td3">
                  <p>{{ item.event }}</p>
                </div>
                <div class="td td4">
                  <p>{{ item.gtd }}</p>
                </div>
                <div class="td td5">
                  <p>{{ item.buy_in + '/' + item.rebuy + '/' + item.add_on }}</p>
                </div>
                <div class="td td6">
                  <p>{{ item.starting_chips / 1000 }}K</p>
                </div>
                <div class="td td7">
                  <p>{{ item.blinds_up.toLocaleUpperCase() }}</p>
                </div>
                <div class="td td8">
                  <p>LV.{{ item.late_reg }}</p>
                </div>
              </div>
            </div>
            <div v-if="scheduleList.length === 0">
              <div class="no_record">
                <p class="no_record_p"><img src="/ppst/static/img/ppst/noseach_icon_pc.png" /> <span>No records found</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="lang === 'pt'" class="realtime_tips">*Os eventos estarão disponíveis em todos os clubes da <a class="to_link" target="_blank" href="https://www.instagram.com/ligabrasil388/">Liga Brasil 388</a> e <a class="to_link" target="_blank" href="https://www.instagram.com/supremapoker/">Liga Suprema 828</a>.</p>
  </div>
</template>

<script>
  import moment from 'moment-timezone'
  import {
    get_leader_board_cycle
  } from '@/api/official'

  export default {
    props: {
      param: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        scheduleList: [],
        lang: this.$route.params.lang || 'en',
        zone: '',
        header: ['DATE', 'TIME', 'EVENT', 'GTD', ['BUY-IN/','REBUY/','ADD-ON'], ['STARTING', 'CHIPS'], 'BLINDS UP', 'LATE REG.'],
        temp: {
          en: ['DATE', 'TIME', 'EVENT', 'GTD', ['BUY-IN/','REBUY/','ADD-ON'], ['STARTING', 'CHIPS'], 'BLINDS UP', 'LATE REG.'],
          es: ['FECHA', 'HORA', 'EVENTO', 'GTD', ['BUY-IN/','REBUY/','ADD-ON'], ['FICHAS', 'INICIALES'], 'BLINDS', 'REGISTRO TARDÍO'],
          ru: ['ДАТА', 'ВРЕМЯ', 'СОБЫТИЕ', 'GTD', ['БАЙ-ИН/','РЕБАЙ/','АДДОН'], ['СТАРТОВЫЙ', 'СТЭК'], 'ПОВЫШЕНИЕ БЛАЙНДОВ', 'ПОЗДНЯЯ РЕГИСТРАЦИЯ'],
          pt: ['DATA', 'HORÁRIO', 'EVENTO', 'GTD', ['BUY-IN/','REBUY/','ADD-ON'], ['STACK', 'INICIAL'], 'BLINDS', 'REG. TARDIO']
        },
        cycle: [],
        schedule_name: '',
        special: false
      }
    },
    filters: {
      format: function(value) {
        return moment(new Date(value)).format('M / D')
      }
    },
    computed: {
      scheduleFormat: function() {
        let result = []
        let ele = {
          date: '',
          list: []
        }
        this.scheduleList.forEach((item, index) => {
          if(index === 0) {
            ele.date = item.date
            ele.list = []
            ele.list.push(item)
          }else if(item.date !== this.scheduleList[index - 1].date) {
            result.push(ele)
            ele = {}
            ele.date = item.date
            ele.list = []
            ele.list.push(item)
          }else {
            ele.list.push(item)
          }
          return true
        })

        if(result.length) {
          result.push(ele)
        }
        return result
      }
    },
    methods: {
      initCycle() {
        let group_type = this.lang === 'pt' ? 'brazil' : 'other'
        get_leader_board_cycle({
          group_type,
        })
          .then(res => {
            this.scheduleList = res.data.list.length ? res.data.list[0].list : [],
            this.zone = res.data.list.length ? res.data.list[0].time_zone : 'America/New_York'
            this.schedule_name = res.data.list.length ? res.data.list[0].schedule_name : ''
            this.changeTableHead(res.data.list.length ? res.data.list[0].lang : 'en')
            this.cycle = res.data.list
          })
          .catch(err => {
            console.log(err)
          })
      },
      changeTableHead(lan) {
        let lang = lan.toLowerCase() || 'en'
        this.special = false
        if(lang === 'ru') {
          this.special = true
        }
        this.header = this.temp[lang] ? this.temp[lang] : this.temp.en
      },
      changeData(zone) {
        this.scheduleList = this.scheduleList.map((item) => {
          let now = moment.tz(moment(new Date(item.date.replace(/\//g, '-') + ' ' + item.time)).format('YYYY-MM-DD HH:mm'), this.zone);
          let date = now.tz(zone).format('YYYY/MM/DD')
          let time = now.tz(zone).format('HH:mm')

          return { ...item, date, time}
        })
        this.zone = zone
      },
      changeSchedule(item) {
        if(this.schedule_name !== item.schedule_name) {
          this.schedule_name = item.schedule_name
          this.scheduleList = this.cycle.filter(it => {
            return it.schedule_name === item.schedule_name
          })[0].list
          this.zone = item.time_zone
          this.changeTableHead(item.lang)
        }
      }
    },
    mounted() {
      this.initCycle()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .realtime_tips {
    font-size: 14px;
    margin-top: 8px;
    margin-bottom: 0px;
    a {
      font-size: 14px;
    }
  }
    .shcedule-con {
      width: 100%;
      // height: 700px;
      background-color: #1a5c44;

      .table {
        width: 100%;
        height: 100%;
        .table-header.special .td p {
          font-size: 13px;
        }
        .table-header {
          background-color: #08e07d;

          .td {
            padding: 10px 0px;
            text-align: left;
            vertical-align: top;
            display: inline-block;

            p {
              margin: 0px;
              font-size: 16px;
              line-height: 22px;
              color: #ffffff;
              font-weight: 500;
            }
            .utc-p {
              font-size: 14px;
              font-weight: 100;
            }
          }
        }
        .over_body {
          width: 100%;
          height: 620px;
        }
        .no_record {
          margin-top: 93px;
          .no_record_p {
            position: relative;
            top: 49%;
            text-align: center;
            line-height: 21px;
            img {
              display: inline-block;
              vertical-align: middle;
              width: 21px;
              height: 21px;
              margin-right: 5px;
            }
            span {
              line-height: 21px;
              font-size: 16px;
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
        .table_big_item {
          position: relative;
          background-color: #1a5c44;
          .schedule_date {
            position: absolute;
            width: 13%;
            height: 100%;
            p {
              position:absolute;
              left:50%;
              color: #00ffa8;
              font-size: 22px;
              top:50%;
              transform:translate(-50%,-50%);
            }
          }
          .table_item {
            .td {
              padding: 12px 0px;
              text-align: left;
              vertical-align: top;
              overflow: hidden;
              // width: 12%;
              display: inline-block;

              p {
                // padding: 0px 20px;
                margin: 0px;
                font-size: 16px;
                color: #bfeddc;
              }
            }
            .td1 {
              p {
                font-size: 18px;
                color: #00ffa8;
              }
            }
          }
          .table_item.hl {
            .td p{
              color: #fcff21;
            }
          }
        }

        .table_big_item:nth-child(2n+1) {
          background-color: #1f6d51;
          .td {
            p {
              color: #00ffa8;
            }
          }
        }

        .td1 {
          width: 13%;
          p {
            padding-left: 20px;
          }
        }

        .td2 {
          width: 9%;
        }

        .td3 {
          width: 24%;
        }

        .td4 {
          width: 8%;
        }
        .td5 {
          width: 12%;
          p {
            word-break: break-word;
          }
        }
        .td6 {
          width: 10%;
        }
        .td7 {
          width: 12%;
        }
        .td8 {
          width: 12%;
        }
      }

      .shcedule {
        width: 100%;
        height: 828px;

        .shcedule-img {
          width: 100%;
          // width: calc(100% - 10px);
          // height: 828px;
          display: block;
        }
      }
      .no_record_p {
        position: relative;
        top: 49%;
        text-align: center;
        line-height: 21px;
        img {
          display: inline-block;
          vertical-align: middle;
          width: 21px;
          height: 21px;
          margin-right: 5px;
        }
        span {
          line-height: 21px;
          font-size: 16px;
          display: inline-block;
          vertical-align: middle;
        }
      }
    }
</style>
